var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-skeleton-table',{attrs:{"rows":4,"columns":4,"table-props":{ bordered: true, striped: true }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }